// extracted by mini-css-extract-plugin
export default {"element":"AboutProjectItem_element__iKhcx","thin_heading":"AboutProjectItem_thin_heading__sqVRx","line-transfer":"AboutProjectItem_line-transfer__uAx81"};